module.exports = __webpack_public_path__ + "static/fonts/UTM-Mabella.4008cb2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/UTM-Mabella.ttf
// module id = o3wb
// module chunks = 0